export const serverPath = 'https://resisted-amethyst-danger.glitch.me/';